import {FavCustomizeView} from "module/selpan/menu/FavCustomizeView";
import template_FavCustomIncludeExcludeView from './FavCustomIncludeExcludeView.ejs';

/**
 * only controls SelPanView.status modes
 */
export const FavCustomIncludeExcludeView = FavCustomizeView.extend({
	render: function () {
		let include = this.fav.custom.get('include');
		include = include && include.get('value');
		include = include && include.length;
		let exclude = this.fav.custom.get('exclude');
		exclude = exclude && exclude.get('value');
		exclude = exclude && exclude.length;
		this.$el.html(template_FavCustomIncludeExcludeView({
			hasData: {
				include: include && 'MenuAccent' || '',
				exclude: exclude && 'MenuAccent' || '',
				includeExclude: (include || exclude) && 'MenuAccent' || '',
			}
		}));
	}
});